import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

export const documentsBreadcrumb = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
}
